import styled from "styled-components";
import { Container } from "@ubnt/store.core/lib/components/Container";

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  overflow: hidden;
`;

export const StyledContainer = styled(Container)`
  overflow: visible;
`;
